const avatars = [
  {name:"Sacha", imgFull:"sacha.png", imgPortrait:"sacha.png",},
  {name:"Néphie", imgFull:"nephie.png", imgPortrait:"nephie.png",},
  {name:"Kiawé", imgFull:"kiawe.png", imgPortrait:"kiawe.png",},
  {name:"Lilie", imgFull:"lilie.png", imgPortrait:"lilie.png",},
  {name:"Chrys", imgFull:"chrys.png", imgPortrait:"chrys.png",},
]
export default avatars